import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
export class LangGuardService {
    constructor(translate) {
        this.translate = translate;
    }
    canActivate(route, state) {
        const lang = route.paramMap.get('lang');
        // 設定i18n
        // this.translate.setDefaultLang(lang);
        this.translate.use(lang);
        return true;
    }
}
LangGuardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LangGuardService_Factory() { return new LangGuardService(i0.ɵɵinject(i1.TranslateService)); }, token: LangGuardService, providedIn: "root" });
